import {gql} from '@apollo/client'

export const GET_ADMIN_NOTIFICATIONS = gql`
  query AdminNotifications(
    $page: Int
    $pageSize: Int
    $types: [String!]
    $unreadOnly: Boolean
    $startDate: String
    $endDate: String
  ) {
    getAdminNotificationsR(
      page: $page
      pageSize: $pageSize
      types: $types
      unreadOnly: $unreadOnly
      startDate: $startDate
      endDate: $endDate
    ) {
      status
      message
      unreadCount
      totalDocs
      page
      totalPages
      hasNextPage
      data {
        _id
        type
        severity
        title
        body
        count
        isRead
        lastEventAt
        createdAt
        entity {
          kind
          id
        }
        actor {
          userId
          name
          email
        }
        meta {
          supportTicketID
          category
          subject
          subscription
          job
          provider
          operation
          errorMessage
          failedBatches
          reason
          notificationType
          notificationSubtype
          notificationUUID
          environment
          bundleId
          productId
          originalTransactionId
          purchaseToken
          winnerUserId
          loserUserIds
          rowCount
          source
          transactionId
          userId
          platform
          mode
          payloadSummary
        }
      }
    }
  }
`

export const GET_ADMIN_NOTIFICATION_UNREAD_COUNT = gql`
  query AdminNotificationUnreadCount {
    getAdminNotificationUnreadCountR {
      total
      countsByType {
        type
        count
      }
    }
  }
`

export const MARK_ADMIN_NOTIFICATIONS_READ = gql`
  mutation MarkAdminNotificationsRead($ids: [String!]!) {
    markAdminNotificationsReadR(ids: $ids) {
      updated
      unreadTotal
    }
  }
`

export const MARK_ALL_ADMIN_NOTIFICATIONS_READ = gql`
  mutation MarkAllAdminNotificationsRead($types: [String!]) {
    markAllAdminNotificationsReadR(types: $types) {
      updated
      unreadTotal
    }
  }
`
